import { render, staticRenderFns } from "./ModalListOfLogs.vue?vue&type=template&id=6c9f2dae&scoped=true&"
import script from "./ModalListOfLogs.vue?vue&type=script&lang=js&"
export * from "./ModalListOfLogs.vue?vue&type=script&lang=js&"
import style0 from "./ModalListOfLogs.vue?vue&type=style&index=0&id=6c9f2dae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9f2dae",
  null
  
)

export default component.exports